import * as React from 'react';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { HomePageSustainabilityContent } from '../../../graphql/pimcore/modules/siteContent/types/HomePageContent';
import './sustainability.css';

type SustainabilitySmallLayoutProps = {
    cmsContent: HomePageSustainabilityContent;
};

export default function SustainabilitySmallLayout({ cmsContent }: SustainabilitySmallLayoutProps) {
    const { title, subtitle, titleBackgroundImage, mainText, detailsLink } = cmsContent;
    const subtitleLines = subtitle.content.split('\n') ?? [];

    return (
        // <div className="sustainability-styling">
        <div className="orange-background">
            <div
                className="orange-background-with-image"
                style={
                    {
                        /* override only the background URL, other styles are inherited from CSS file */
                        '--sust-bg-url': `url(${titleBackgroundImage.imageUrl})`,
                    } as React.CSSProperties
                }
            >
                <div className="sustainability-container">
                    <div className="top-container ">
                        <div className="sustainability-title">{title.content}</div>
                        <div className="commitment">
                            {subtitleLines.map((line, i) => (
                                <span key={i}>
                                    {line}
                                    {i < subtitleLines.length - 1 && <br />}
                                </span>
                            ))}
                        </div>
                    </div>
                    <div className="bottom-container">
                        <div className="sustainability-text">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: mainText.sanitizedContent,
                                }}
                            />
                            <div className="our-efforts">
                                <Typography fontSize="1.5rem" fontWeight="400">
                                    <Link to={detailsLink.linkRoute} className="effort-styling">
                                        <ArrowForwardIcon style={{ fontSize: 'large' }} />{' '}
                                        {detailsLink.linkText}
                                    </Link>
                                    {/*<a href="/client/src/static#" className="impact-styling">*/}
                                    {/*    <ArrowForwardIcon style={{ fontSize: 'large' }} />{' '}*/}
                                    {/*    <FormattedMessage*/}
                                    {/*        id="OurImpact"*/}
                                    {/*        defaultMessage="Our Impact"*/}
                                    {/*    />*/}
                                    {/*</a>*/}
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
